import { render, staticRenderFns } from "./notifications.page.vue?vue&type=template&id=3987d28c&scoped=true&"
import script from "./notifications.page.vue?vue&type=script&lang=js&"
export * from "./notifications.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987d28c",
  null
  
)

export default component.exports